// JsFromRoutes CacheKey f3675bdc4b870a32e837dc3faea5bf28
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  purchase: /* #__PURE__ */ definePathHelper('post', '/consumer/orders/:id/purchase'),
  verifyGifter: /* #__PURE__ */ definePathHelper('post', '/consumer/orders/:id/verify_gifter'),
  verifyGifterBySms: /* #__PURE__ */ definePathHelper('post', '/consumer/orders/:id/verify_gifter_by_sms'),
  resendGifterVerificationSms: /* #__PURE__ */ definePathHelper('post', '/consumer/orders/:id/resend_gifter_verification_sms'),
  confirmGifterFromCode: /* #__PURE__ */ definePathHelper('post', '/consumer/orders/:id/confirm_gifter_from_code'),
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/orders/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/consumer/orders/:id'),
  confirmGifterFromEmail: /* #__PURE__ */ definePathHelper('get', '/verify/buyer/:token'),
}
